import { createContext } from 'react'
import { Context, MagentoCountryCodeEnum } from 'lib/types'
import { DEFAULT_PATH } from 'lib/core/resources/constants'

/*
 * Core
 */

export const CoreContext = createContext<Context>({
  checkoutCountries: [MagentoCountryCodeEnum.US],
  path: {
    ...DEFAULT_PATH
  }
})

/*
 * Checkout
 */

export type CheckoutContextState = Record<string, any>
export type CheckoutContextSetStateParam = ((state: CheckoutContextState) => CheckoutContextState) | CheckoutContextState

export interface CheckoutContextValue {
  state: CheckoutContextState
  setState: (state: CheckoutContextSetStateParam) => void
}

export const CheckoutContext = createContext<CheckoutContextValue>({
  state: {},
  setState: () => undefined
})
